import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class MainNavService {
  serverUrl = environment.serverUrl;

  constructor( public httpClient: HttpClient) { }

  generalSearch(value){
   return  this.httpClient.get(this.serverUrl + '/search/elastic/',
      {
        params: new HttpParams().set('q', value)
      }
    )
  }
}
